import { Carousel, Col, Container, Row } from "react-bootstrap";
import slider from "../../assets/projects/2024/satoshi/slider.png";
import img01 from "../../assets/projects/2024/satoshi/01.png";
import img02 from "../../assets/projects/2024/satoshi/02.png";
import img03 from "../../assets/projects/2024/satoshi/03.png";
import img04 from "../../assets/projects/2024/satoshi/04.png";
import img05 from "../../assets/projects/2024/satoshi/05.png";
import carousel01 from "../../assets/projects/2024/satoshi/carousel01.png";
import carousel02 from "../../assets/projects/2024/satoshi/carousel02.png";
import carousel03 from "../../assets/projects/2024/satoshi/carousel03.png";
import carousel04 from "../../assets/projects/2024/satoshi/carousel04.png";
import video from "../../assets/projects/2024/satoshi/Videos/01.mp4";
import { useEffect, useRef } from "react";

import ReactTranslated from "react-translated";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";

const Project_Satoshi = () => {
  const title = "Satoshi Tango";

  const videoEl = useRef(null);

  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch((error) => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <>
      <Container className="container_projects p-0 m-0">
        <Row className="pb-md-5 pb-4">
          <Col>
            <img src={slider} alt={title} />
          </Col>
        </Row>
        <Row className="pt-md-5 pb-md-5 pt-4 pb-4">
          <Col md={12} xs={11} className="mx-auto">
            <p className="subtituloProject">
              <ReactTranslated.Translate text="satoshi1" />
            </p>
            <p className="tituloProject">
              <b>Satoshi Tango!</b>
            </p>
          </Col>
        </Row>
        <Row className="pb-md-5 pb-4">
          <Col>
            <img src={img01} alt={title} />
          </Col>
        </Row>
        <Row className="pt-md-0 pb-md-5 pt-4 pb-4">
          <Col md={6} xs={0} className="mx-auto" />
          <Col md={6} xs={11} className="mx-auto">
            <p>
              <ReactTranslated.Translate text="satoshi2" />
            </p>
          </Col>
        </Row>
        <Row className="pb-md-5 pb-4">
          <Col>
            <img src={img02} alt={title} />
          </Col>
        </Row>
        <Row className="pb-md-5 pb-4">
          <Col>
            <img src={img03} alt={title} />
          </Col>
        </Row>
        <Row className="pt-md-5 pb-md-5 pt-4 pb-4">
          <Col>
            <Carousel>
              <Carousel.Item>
                <img src={carousel01} alt={title} />
              </Carousel.Item>
              <Carousel.Item>
                <img src={carousel02} alt={title} />
              </Carousel.Item>
              <Carousel.Item>
                <img src={carousel03} alt={title} />
              </Carousel.Item>
              <Carousel.Item>
                <img src={carousel04} alt={title} />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
        <Row className="pb-md-5 pb-4">
          <Col>
            <img src={img04} alt={title} />
          </Col>
        </Row>
        <Row className="pt-md-0 pb-md-5 pt-4 pb-4">
          <Col md={6} xs={0} className="mx-auto" />
          <Col md={6} xs={11} className="mx-auto">
            <p>
              <ReactTranslated.Translate text="satoshi3" />
            </p>
          </Col>
        </Row>
        <Row className="pb-md-5 pb-4">
          <Col>
            <img src={img05} alt={title} />
          </Col>
        </Row>

        <Row className="pt-md-5 pb-md-5 pt-4 pb-4">
          <Col>
            {" "}
            <div className="text-center ">
              <video
                style={{ maxWidth: "100%", margin: "0 auto" }}
                playsInline
                loop
                muted
                alt="WOP"
                src={video}
                ref={videoEl}
              />
            </div>
          </Col>
        </Row>
        <Row className="pt-md-5 pb-md-5 pt-4 pb-4">
          <Col md={3} xs={11} className="pt-md-0 pb-md-0 pt-4 pb-4 mx-auto">
            <p style={{ whiteSpace: "pre-line", fontWeight: "bold" }} className="pb-4">
              {" "}
              <ReactTranslated.Translate text="titleproject242" />
            </p>
            <p style={{ whiteSpace: "pre-line", lineHeight: "16px" }}>
              {" "}
              <ReactTranslated.Translate text="satoshi4" />
            </p>
          </Col>
          <Col md={3} xs={11} className="pt-md-0 pb-md-0 pt-4 pb-4 mx-auto">
            <p style={{ whiteSpace: "pre-line", fontWeight: "bold" }} className="pb-4">
              {" "}
              <ReactTranslated.Translate text="titleproject243" />
            </p>
            <p style={{ whiteSpace: "pre-line", lineHeight: "16px" }}>
              <ReactTranslated.Translate text="satoshi5" />
            </p>
          </Col>
          <Col md={3} xs={11} className="pt-md-0 pb-md-0 pt-4 pb-4 mx-auto">
            <p style={{ whiteSpace: "pre-line", fontWeight: "bold" }} className="pb-4">
              {" "}
              <ReactTranslated.Translate text="titleproject244" />
            </p>
            <p style={{ whiteSpace: "pre-line", lineHeight: "16px" }}>2023</p>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-between pt-md-5 pb-md-5 pt-4 pb-4 pe-md-5 pe-2">
            <Link to="/projects/hicampus" className="linkNext">
              <span>{"<<"}</span> <ReactTranslated.Translate text="linkback" />
            </Link>
            <Link to="/projects/amadeus" className="linkNext rightN">
              <ReactTranslated.Translate text="linknext" /> >>
            </Link>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default Project_Satoshi;
